export const EVENTS_COLORS = [
  "#27A69A",
  "#1A7BEE",
  "#D74DA2",
  "#4ADB84",
  "#8D52EE",
  "#00569D",
];

export const EVENTS_BORDERS_COLORS = [
  "#27A69A",
  "#1A7BEE",
  "#D74DA2",
  "#4ADB84",
  "#8D52EE",
  "#00569D",
];

export const RESOURCE_TASK_COLORS = {
  GREEN: "#0DB952",
  YELLOW: "#FAC936",
  ICON: "#717986",
  ICON2: "#FE7043",
};
